import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import userLogout from "./userLogout";
import { useDispatch } from "react-redux";
import saveAuthToken from "./saveAuthToken";

const useClassroomVideoData = (id) => {
  const [videosData, setVideosData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchVideoData = async (retries = 6) => {
    try {
      const authToken = sessionStorage.getItem("token");
      const requestOptions = {
        method: "GET",
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_VIDEO_DATA + id,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchVideoData(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setVideosData(json?.data);
      saveAuthToken(json?.data?.token);
    } catch (err) {
      console.error("Error fetchVideoData", err);
    }
  };

  useEffect(() => {
    fetchVideoData();
  }, [id]);

  return videosData;
};

export default useClassroomVideoData;
